<kgr-modal
  (closeModal)="cancel()"
  [open]="show"
  [closeOnBackdropClick]="false"
  [width]="width"
  [fullWidth]="fullWidth"
  [height]="height"
  [fullHeight]="fullHeight"
  [loading]="loading"
>
  <kgr-modal-header [headline]="headline"></kgr-modal-header>
  <kgr-modal-content>
    <ng-content>
      {{ text }}
    </ng-content>
  </kgr-modal-content>
  <kgr-modal-footer class="kgr-postfix kgr-postfix--gutters kgr-postfix--center">
    <div class="kgr-postfix__fixed">
      <button type="reset" class="kgr-button kgr-button--outline" (click)="cancel()">{{ cancelButtonLabel }}</button>
    </div>
    <div class="kgr-postfix__fluid"></div>
    @if (showDeclineButton) {
      <div class="kgr-postfix__fixed">
        <button type="button" class="kgr-button {{ declineButtonCssClass }}" (click)="decline()" i18n>
          {{ declineButtonLabel }}
        </button>
      </div>
    }
    <div class="kgr-postfix__fixed">
      <button type="button" class="kgr-button {{ confirmButtonCssClass }}" (click)="confirm()" i18n>
        {{ confirmButtonLabel }}
      </button>
    </div>
  </kgr-modal-footer>
</kgr-modal>
